package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.Image
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.DrawerDefaults
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.ModalDrawerSheet
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.home.LocalIsPreview
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.google_logo_dark
import com.nonopn.skywatcher.common.app.res.preview
import com.nonopn.skywatcher.design.menu.ModalNavigationRightToLeft
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.compose.widgets.TextNormal
import org.jetbrains.compose.resources.painterResource
import com.nonopn.skydome.common.app.pages.fullscreenmap.FullscreenMapContainer
import ovh.plrapps.mapcompose.ui.MapUI

@Composable
fun EstimateMap(
    modifier: Modifier,
    model: EstimateScreenModel
) {
    if (LocalIsPreview.current) {
        Column(
            modifier = modifier,
        ) {
            Image(
                painter = painterResource(Res.drawable.preview),
                contentDescription = ""
            )
        }
        return
    }

    model.configureMapState()

    MapBox(modifier, model)
}

@Composable
private fun MapBox(modifier: Modifier, model: EstimateScreenModel) {
    val state by model.states.collectAsState()

    if (!state.initialized) {
        return
    }

    val lightningDrawerState = rememberDrawerState(DrawerValue.Closed)

    val color = if (LocalDarkTheme.current) {
        AppColor.BackgroundBlue
    } else {
        AppColor.WhiteCream
    }

    val showDrawer = model.validationMode == EstimateValidationMode.AdminCanValidate

    ModalNavigationRightToLeft(
        drawerContent = {
            if (!showDrawer) {
                return@ModalNavigationRightToLeft
            }

            ModalDrawerSheet(
                drawerShape = DrawerDefaults.shape,
                drawerContainerColor = color,
                drawerTonalElevation = 2.dp
            ) {
                EstimateMapRightColumn(Modifier.width(250.dp).fillMaxHeight(), model)
            }
        },
        gesturesEnabled = lightningDrawerState.isOpen,
        drawerState = lightningDrawerState
    ) {
        FullscreenMapContainer(
            modifier = modifier,
            // The corners are used by the estimate overlay
            controlsAlignment = Alignment.BottomCenter,
            closeAlignment = Alignment.TopEnd,
            controlsPadding = 12.dp,
        ) { isFullscreen ->
            MapUI(
                modifier = Modifier.fillMaxSize(),
                state = model.mapState
            )

            Row(
                modifier = Modifier.align(Alignment.BottomStart).padding(12.dp),
                verticalAlignment = Alignment.Bottom
            ) {
                Image(
                    modifier = Modifier.height(15.dp),
                    painter = painterResource(Res.drawable.google_logo_dark),
                    contentDescription = ""
                )
            }

            Row(
                modifier = Modifier.align(Alignment.BottomEnd).padding(12.dp),
                verticalAlignment = Alignment.Bottom
            ) {
                TextNormal(
                    text = LocalApp.current.appTitle.localized()
                )
            }

            // The overlay (validation, settings drawer) belongs to the screen, not to the full screen map
            if (!isFullscreen) {
                EstimateMapOverlay(
                    modifier = Modifier.fillMaxSize(),
                    model,
                    lightningDrawerState
                )
            }
        }
    }
}

@HotPreview(widthDp = 400, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150, darkMode = false)
@Composable
private fun EstimateMapPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme(), isPreview = true) {
        EstimateMap(
            Modifier.fillMaxSize(),
            FakeEstimateScreenModel(
                false
            )
        )
    }
}
